export default __webpack_public_path__ + "static/media/logo.ebdb726d.svg";